<div class="select-tag-container">
  <h4>Tags</h4>
  <select class="form-control" id="select-tag" [(ngModel)]="selectedTag">
    <option value="" selected>Select</option>
    @for (tag of filterTags; track tag) {
      <option [value]="tag.tag_id">{{tag.tag_name}}</option>
    }
  </select>
  <button class="btn btn-primary btn-block" (click)="addTag()">Filter</button>
</div>

<div class="selected-tags">
  @for (t of selectedTags; track t) {
    <div>
      <button class="btn btn-primary btn-remove" (click)="removeTag(t.tag_id)">
        <span>{{t.tag_name}}</span>
      </button>
    </div>
  }
</div>
